import { render, staticRenderFns } from "./BasicFormComponent.vue?vue&type=template&id=cfb7584e&scoped=true&"
import script from "./BasicFormComponent.vue?vue&type=script&lang=js&"
export * from "./BasicFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb7584e",
  null
  
)

export default component.exports